const addProductHistory = (productID, variantID, url, viewedTime) => {
    const saveToLocalStorage = (newItem) => {
        const arrayUniqueByKey = [...new Map(newItem.map(item => [item['productID'], item])).values()];
        return localStorage.setItem("pa_recently_viewed", JSON.stringify(arrayUniqueByKey));
    };

    let historyString = localStorage.getItem("pa_recently_viewed");
    let productHistory = JSON.parse(historyString);
    let storageObject = {
        productID: productID,
        variantID: variantID,
        baseURI: url,
        lastViewedAt: viewedTime
    };

    if (productHistory == null) {
        return saveToLocalStorage([storageObject]);
        // TODO: Increase storage limit in production?
        // NOTE: 100 is ~16.14kb
    } else if (productHistory.length < 100) {
        productHistory.push(storageObject);
        return saveToLocalStorage(productHistory);
    } else if (productHistory.length == 100) {
        productHistory.push(storageObject);
        productHistory.shift();
        return saveToLocalStorage(productHistory);
    };
};

const toRelativeURL = (url) => {
    const {pathname, search} = new URL(url);
    return pathname + search;
}

addProductHistory(selectedProductID, selectedVariantID, selectedProductURI, viewedTime);

let originalVariant;
const disableUnavailableSizes = () => {
    const availableSizes = [];

    productVariants.forEach(variant => {
        const color = document.querySelector('.product-form__input input[name="Color"]:checked');
        let colorExistsForSize = false;
        if (color) {
            colorExistsForSize = (color.value.replaceAll('-', '') === variant.option1.replaceAll('-', ''));
        }
        const disableOption = () => {
            try{
                document.querySelector(`.product-form__input input[name="Shoe Size"][value="${variant.option2}"]`).disabled = true;
            } catch (err) {
                //pass
            }
            try{
                document.querySelector(`.product-form__input input[name="Size"][value="${variant.option2}"]`).disabled = true;
            } catch (err) {
                //pass
            }
        }
        if (!availableSizes.includes(variant.option2) && document.querySelector(`.product-form__input input[name="Size"][value="${variant.option2}"]`)) {
            disableOption();
        }
        if (!availableSizes.includes(variant.option2) && document.querySelector(`.product-form__input input[name="Shoe Size"][value="${variant.option2}"]`)) {
            disableOption();
        }
        if (colorExistsForSize) {
            if (document.querySelector(`.product-form__input input[name="Size"][value="${variant.option2}"]`)) {
                if (variant.available) {
                    availableSizes.push(variant.option2);
                    document.querySelector(`.product-form__input input[name="Size"][value="${variant.option2}"]`).disabled = false;
                } else {
                    disableOption();
                }
            }

            if (document.querySelector(`.product-form__input input[name="Shoe Size"][value="${variant.option2}"]`)) {
                if (variant.available) {
                    availableSizes.push(variant.option2);
                    document.querySelector(`.product-form__input input[name="Shoe Size"][value="${variant.option2}"]`).disabled = false;
                } else {
                    disableOption();
                }
            }
        }
    });

    return availableSizes;
}

document.addEventListener('change', (e) => {
    if (e.target.attributes[1].value == 'id') {  
        const parsedBaseURI = toRelativeURL(e.target.baseURI)
        let viewedTime = new Date().toISOString()
        addProductHistory(selectedProductID, e.target.value, parsedBaseURI, viewedTime);
    }
    const showMedia = (currentAlt) => {
        document.getElementById('color-selector-current-value').innerText = currentAlt;
        productMedia.forEach(media => {
            const mediaElementName = `${sectionID}-${media.id}`;
            if (document.querySelector(`[data-media-id='${mediaElementName}']`)) {
                   /* Show only pictures for currently selected variant */
                if (media.alt && media.alt.replaceAll('-', '') === currentAlt.replaceAll('-', '')) {
                    document.querySelector(`[data-media-id='${mediaElementName}']`).style.display = 'list-item';
                } else {
                    // Hide other variant images
                    document.querySelector(`[data-media-id='${mediaElementName}']`).style.display = 'none';
                }
                // Show/Hide modal images
                if (document.querySelector(`.product-media-modal__content img[data-media-id='${media.id}']`)) {
                    if (media.alt.replaceAll('-', '') === currentAlt.replaceAll('-', '')) {
                        document.querySelector(`.product-media-modal__content img[data-media-id='${media.id}']`).style.display = 'block';
                    } else {
                        // Hide other variant images
                        document.querySelector(`.product-media-modal__content img[data-media-id='${media.id}']`).style.display = 'none';
                    }
                }
            }
        });
        document.querySelector('slider-component').initPages();
    }
    disableUnavailableSizes()
    if (e.target.name === 'Color') {
        
        let currentAlt = e.target.value;

        if (document.querySelector('deferred-media button')) {
            document.querySelector('deferred-media button').click()
            if (document.querySelector(`video`)) {
                document.querySelector(`video`).loop = true;
                document.querySelector(`video`).play()
            }
        }
        const color = document.querySelector('.product-form__input input[name="Color"]:checked');

        showMedia(currentAlt);
        // show unavailable sizes
        const availableSizes = disableUnavailableSizes();
        if (!availableSizes.includes(color.value) && availableSizes.length > 0) {
            try {
                document.querySelector(`.product-form__input input[name="Size"][value="${availableSizes[0]}"]`).checked = true;
            } catch (err) {
                // pass
            }
            try {
                document.querySelector(`.product-form__input input[name="Shoe Size"][value="${availableSizes[0]}"]`).checked = true;
            } catch (err) {
                // pass
            }
            document.querySelector('variant-radios').onVariantChange();
        }
    } else if (e.target.name == 'Size') {
        // let newSelection = false;
        // Uncomment to automatcally select available variant
        // productVariants.forEach(variant => {
        //     if (variant.available && !newSelection) {
        //         const color = document.querySelector('.product-form__input input[name="Color"]:checked');
        //         const size = document.querySelector('.product-form__input input[name="Size"]:checked');
        //         const selectionExists = (variant.option2 == e.target.value && variant.option1.replace('-', '') == color.value);

        //         if (!selectionExists && variant.option2 == e.target.value) {
        //             const newColor = variant.option1.replace('-','')
        //             document.querySelector(`.product-form__input input[name="Color"][value="${newColor}"]`).checked = true;
        //             document.querySelector('variant-radios').onVariantChange();
        //             showMedia(newColor);
        //             newSelection = true;
        //         }
        //     }
        // });

    }

});
disableUnavailableSizes()

